<template>
    <div class="second-number-refresh">
        <div class="page-head">
            <img class="back-icon" src="../../../assets/images/fh.png" alt="" @click="backBefor" />
            <div class="head-copy">
                <p>号码服务</p>
                <h1>二次号码焕新</h1>
                <span>为当前绑定号码发起互联网账号解绑服务</span>
            </div>
            <div class="signal-card">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>

        <div class="content">
            <div class="service-card">
                <div class="service-title">
                    <span class="refresh-mark"></span>
                    <div>
                        <h2>一键发起焕新</h2>
                        <p>提交后将跳转至服务页面继续办理</p>
                    </div>
                </div>
                <van-button
                    round
                    block
                    :loading="loading"
                    loading-text="正在获取链接"
                    class="main-button"
                    @click="handleRefresh"
                >
                    立即办理
                </van-button>
            </div>

            <div class="agreement">
                <van-checkbox v-model="checked" shape="square" class="agreement-check"></van-checkbox>
                <span>我已阅读并同意</span>
                <span class="agreement-link" @click="showAgreement = true">《服务开通及用户协议》</span>
            </div>
        </div>

        <van-popup v-model="showAgreement" round closeable position="bottom" class="agreement-popup">
            <div class="popup-content">
                <h3>服务开通及用户协议</h3>
                <UserAgreement />
                <van-button round block type="info" @click="confirmAgreement">我已阅读并同意</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
import API from "../../../common/api/api"
import { Toast } from "vant"
import UserAgreement from "./UserAgreement.vue"

export default {
    name: "SecondNumberRefresh",
    components: {
        UserAgreement,
    },
    data() {
        return {
            checked: false,
            showAgreement: false,
            loading: false,
        }
    },
    methods: {
        backBefor() {
            this.$router.back()
        },
        confirmAgreement() {
            this.checked = true
            this.showAgreement = false
        },
        handleRefresh() {
            if (!this.checked) {
                Toast({
                    message: "请先勾选并阅读《服务开通及用户协议》",
                    position: "bottom",
                })
                return
            }

            if (this.loading) return
            this.loading = true
            const token = localStorage.getItem("token")
            API.getJson("UNBIND_APP", { token: token }).then((res) => {
                if (res && res.url) {
                    window.location.href = res.url
                    return
                }
                Toast({
                    message: "跳转链接为空",
                    position: "bottom",
                })
            }).catch(() => {
            }).finally(() => {
                this.loading = false
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.second-number-refresh {
    min-height: 100vh;
    background: #fffdf0;
    color: #30333a;
}

.page-head {
    position: relative;
    height: px2rem(420);
    padding: px2rem(92) px2rem(44) 0;
    overflow: hidden;
    box-sizing: border-box;
    background: linear-gradient(145deg, #fff7c7 0%, #ffd751 58%, #ffc71a 100%);

    &::after {
        content: "";
        position: absolute;
        right: px2rem(-90);
        bottom: px2rem(-130);
        width: px2rem(330);
        height: px2rem(330);
        border: px2rem(34) solid rgba(255, 255, 255, 0.28);
        border-radius: 50%;
    }
}

.back-icon {
    position: absolute;
    left: px2rem(34);
    top: px2rem(42);
    z-index: 2;
    width: px2rem(34);
    height: px2rem(30);
}

.head-copy {
    position: relative;
    z-index: 1;
    color: #3a3217;

    p {
        display: inline-flex;
        align-items: center;
        height: px2rem(42);
        padding: 0;
        border-radius: 0;
        background: transparent;
        padding: 0 px2rem(18);
        border-radius: px2rem(24);
        background: rgba(255, 255, 255, 0.35);
        color: #6d5510;
        font-size: px2rem(22);
    }

    h1 {
        margin-top: px2rem(28);
        font-size: px2rem(50);
        line-height: px2rem(62);
        font-weight: 700;
        letter-spacing: 0;
    }

    span {
        display: block;
        margin-top: px2rem(14);
        margin-top: px2rem(18);
        color: rgba(58, 50, 23, 0.72);
        font-size: px2rem(25);
        line-height: normal;
    }
}

.signal-card {
    position: absolute;
    right: px2rem(50);
    top: px2rem(118);
    z-index: 1;
    display: flex;
    align-items: flex-end;
    gap: px2rem(10);
    width: px2rem(118);
    height: px2rem(94);
    padding: px2rem(18);
    box-sizing: border-box;
    border: 0;
    border-radius: px2rem(18);
    background: #fff8d8;

    span {
        flex: 1;
        border-radius: px2rem(8);
        background: #ffc71a;

        &:nth-child(1) {
            height: px2rem(28);
            opacity: 0.52;
        }

        &:nth-child(2) {
            height: px2rem(44);
            opacity: 0.72;
        }

        &:nth-child(3) {
            height: px2rem(60);
        }
    }
}

.content {
    position: relative;
    margin-top: px2rem(-78);
    padding: 0 px2rem(30) px2rem(48);
}

.service-card {
    padding: px2rem(38) px2rem(32) px2rem(34);
    border-radius: px2rem(18);
    background: #fff;
    box-shadow: 0 px2rem(12) px2rem(32) rgba(180, 139, 0, 0.12);
}

.service-title {
    display: flex;
    align-items: center;
    gap: px2rem(22);
    margin-bottom: px2rem(34);

    h2 {
        font-size: px2rem(32);
        line-height: px2rem(42);
        font-weight: 600;
        color: #30333a;
    }

    p {
        margin-top: px2rem(8);
        color: #7d8794;
        font-size: px2rem(23);
        line-height: px2rem(32);
    }
}

.refresh-mark {
    position: relative;
    width: px2rem(72);
    height: px2rem(72);
    flex: 0 0 px2rem(72);
    border-radius: px2rem(14);
    background: #fff8d8;

    &::before {
        content: "";
        position: absolute;
        left: px2rem(17);
        top: px2rem(17);
        width: px2rem(30);
        height: px2rem(30);
        border: px2rem(5) solid #ffc71a;
        border-left-color: transparent;
        border-radius: 50%;
    }

    &::after {
        content: "";
        position: absolute;
        right: px2rem(16);
        top: px2rem(18);
        width: 0;
        height: 0;
        border-top: px2rem(9) solid transparent;
        border-bottom: px2rem(9) solid transparent;
        border-left: px2rem(13) solid #ffc71a;
    }
}

.main-button {
    height: px2rem(88);
    border: 0;
    background: #ffc71a;
    color: #30333a;
    font-size: px2rem(29);
    font-weight: 600;
    box-shadow: 0 px2rem(10) px2rem(24) rgba(255, 199, 26, 0.32);
}

.agreement {
    margin-top: px2rem(34);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: px2rem(8);
    color: #8a6b1f;
    font-size: px2rem(24);
}

.agreement-link {
    color: #d48b00;
}

.agreement ::v-deep .van-checkbox {
    display: flex;
    align-items: center;
}

.agreement ::v-deep .van-checkbox__icon {
    width: px2rem(30);
    height: px2rem(30);
    line-height: px2rem(30);
    font-size: px2rem(30);
}

.agreement ::v-deep .van-checkbox__icon .van-icon {
    width: px2rem(30);
    height: px2rem(30);
    line-height: px2rem(30);
    font-size: px2rem(22);
    display: block;
    box-sizing: border-box;
    border-color: #d9b545;
}

.agreement ::v-deep .van-checkbox__icon--checked .van-icon {
    border-color: #ffc71a;
    background-color: #ffc71a;
}

.agreement-popup {
    width: 100%;
    max-height: 84vh;
}

.popup-content {
    padding: px2rem(48) px2rem(24) px2rem(28);

    h3 {
        margin-bottom: px2rem(22);
        text-align: center;
        color: #30333a;
        font-size: px2rem(30);
        font-weight: 600;
    }

    .van-button {
        margin-top: px2rem(26);
        height: px2rem(78);
        color: #30333a;
        font-size: px2rem(28);
        background: #ffc71a;
        border-color: #ffc71a;
    }
}
</style>
